/** @file ringAngleAt: the ring parameter (radians) of the ring point nearest a screen point. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import { screenOf } from '@zilo/pose3d-render-core/camera/screenOf';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';

/**
 * `ring` is a closed polyline sampled evenly from angle 0 to 2 pi (`unitRing` placed in the world); the result is
 * `2 pi i / (n - 1)` for the vertex `i` nearest `(x, y)` on screen: where a rotate drag grabbed the ring.
 */
export function ringAngleAt(ring: readonly Vec3[], view: View, x: number, y: number): number {
  let best = 0;
  let bestD = Infinity;
  ring.forEach((p, i) => {
    const [sx, sy] = screenOf(p, view);
    const d = Math.hypot(sx - x, sy - y);
    if (d < bestD) { bestD = d; best = i; }
  });
  return ring.length > 1 ? (2 * Math.PI * best) / (ring.length - 1) : 0;
}
